import { useCallback, useState } from "react";

export const useForceUpdate = (description: string) => {
  const [token, setState] = useState<symbol>(Symbol(description));

  const update = useCallback(() => setState(Symbol(description)), [description]);

  return [token, update] as const;
}